import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleGuard from "./components/RoleGuard";
import DevPanel from "./components/DevPanel";
import HomeRedirect from "./components/HomeRedirect";
import RequestAccess from "./pages/RequestAccess";
import AccessPending from "./pages/AccessPending";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import Dashboard from "./pages/Dashboard";
import MyReports from "./pages/MyReports";
import SubmitReport from "./pages/SubmitReport";
import Alerts from "./pages/Alerts";
import Organizations from "./pages/Organizations";
import AdminPilot from "./pages/AdminPilot";
import AdminReview from "./pages/AdminReview";
import AdminUsers from "./pages/AdminUsers";
import VerifierQueue from "./pages/VerifierQueue";
import OrganizationReports from "./pages/OrganizationReports";
import Resources from "./pages/Resources";
import Privacy from "./pages/Privacy";

interface AppProps {
  clerkKeyStatus: "present" | "missing" | "malformed";
}

export default function App({ clerkKeyStatus }: AppProps) {
  return (
    <>
      {import.meta.env.DEV && <DevPanel clerkKeyStatus={clerkKeyStatus} />}
      <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomeRedirect />} />
        <Route path="/request-access" element={<RequestAccess />} />
        <Route path="/access-pending" element={<AccessPending />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/sign-up/*" element={<SignUpPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/my-reports" element={<MyReports />} />
          <Route path="/submit-report" element={<SubmitReport />} />
          <Route path="/alerts" element={<Alerts />} />
          <Route path="/organizations" element={<Organizations />} />
          <Route path="/resources" element={<Resources />} />

          <Route
            element={
              <RoleGuard
                allow={["organization_admin", "platform_admin"]}
              />
            }
          >
            <Route
              path="/organization-reports"
              element={<OrganizationReports />}
            />
          </Route>

          <Route
            element={
              <RoleGuard
                allow={["trusted_verifier", "platform_admin"]}
              />
            }
          >
            <Route path="/verifier" element={<VerifierQueue />} />
          </Route>

          <Route element={<RoleGuard allow={["platform_admin"]} />}>
            <Route path="/admin" element={<AdminReview />} />
            <Route path="/admin/pilot" element={<AdminPilot />} />
            <Route path="/admin/users" element={<AdminUsers />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
      </Routes>
    </>
  );
}
